import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SubscriptionListService } from "../subscription-list.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-add-and-edit-subscription-plan",
  templateUrl: "./add-and-edit-subscription-plan.component.html",
  styleUrls: ["./add-and-edit-subscription-plan.component.sass"],
})
export class AddAndEditSubscriptionPlanComponent implements OnChanges {
  @Input() subscriptionData: any;
  @Input() showModal: boolean = false;
  @Output() closeModal = new EventEmitter<void>();
  @Output() save = new EventEmitter<any>();

  subscriptionForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private subscriptionListService: SubscriptionListService
  ) {
    this.initForm();
  }

ngOnChanges(changes: SimpleChanges): void {
  if (changes["subscriptionData"] && this.subscriptionData) {
    this.isUnlimitedKhali = this.subscriptionData.khaliGadiAddPostDays === -1;
    this.isUnlimitedLoad = this.subscriptionData.wantLoadContact === -1;

    this.subscriptionForm.patchValue({
      planName: this.subscriptionData.planName || "",
      planType: this.subscriptionData.planType || null,
      price: this.subscriptionData.price || 0,

      validityDays:
        this.subscriptionData.planType === 3
          ? -1
          : this.subscriptionData.validityDays || null,

      khaliGadiAddPostDays: this.subscriptionData.khaliGadiAddPostDays ?? null,
      wantLoadContact: this.subscriptionData.wantLoadContact ?? null,
      earning: this.subscriptionData.earning || null,
      onlineNotificationDays: this.subscriptionData.onlineNotificationDays || null,
      tax: this.subscriptionData.tax || 0,
      commission: this.subscriptionData.commission || 0,
      discount: this.subscriptionData.discount || 0,
      planIndex: this.subscriptionData.planIndex,
    });

    // 👉 disable validityDays in case of planType 3
    if (this.subscriptionData.planType === 3) {
      this.subscriptionForm.get("validityDays")?.disable();
    } else {
      this.subscriptionForm.get("validityDays")?.enable();
    }
  }
}





  initForm() {
    this.subscriptionForm = this.fb.group({
      planName: ["", [Validators.required, Validators.minLength(3)]],
      planType: [null, [Validators.required]],
      price: [0, [Validators.required, Validators.min(1)]],

      validityDays: [null],
      khaliGadiAddPostDays: [null],
      wantLoadContact: [null],
      earning: [null],
      onlineNotificationDays: [null],

      tax: [0, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      commission: [
        0,
        [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)],
      ],
      discount: [
        0,
        [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)],
      ],
      planIndex: [0, [Validators.required]],
    });

    // Subscribe to planType changes
    this.subscriptionForm
      .get("planType")
      ?.valueChanges.subscribe((planType) => {
        this.updateValidators(planType);
      });
  }
updateValidators(planType: number) {
  // Reset all fields first
  this.clearField("validityDays");
  this.clearField("khaliGadiAddPostDays");
  this.clearField("wantLoadContact");
  this.clearField("earning");
  this.clearField("onlineNotificationDays");

  if (planType === 1) {
    this.setRequired("earning");
    this.setRequired("onlineNotificationDays");
    this.setRequired("khaliGadiAddPostDays");
  } else if (planType === 2) {
    this.setRequired("validityDays");
    this.setRequired("khaliGadiAddPostDays");
    this.setRequired("wantLoadContact");
  } else if (planType === 3) {
    // validityDays always -1 for current plan
    this.subscriptionForm.get("validityDays")?.setValue(-1);

    // Still enforce khaliGadiAddPostDays & wantLoadContact
    this.setRequired("khaliGadiAddPostDays");
    this.setRequired("wantLoadContact");
  }
}



  setRequired(controlName: string) {
    const control = this.subscriptionForm.get(controlName);
    control?.setValidators([Validators.required]);
    control?.updateValueAndValidity();
  }

  clearField(controlName: string) {
    const control = this.subscriptionForm.get(controlName);
    control?.clearValidators();
    control?.setValue(null); // reset to null
    control?.updateValueAndValidity();
  }

  isUnlimitedKhali = false;
  isUnlimitedLoad = false;

  setUnlimitedKhali() {
    this.isUnlimitedKhali = true;
    this.subscriptionForm.get("khaliGadiAddPostDays")?.setValue(-1);
  }

  setCustomKhali() {
    this.isUnlimitedKhali = false;
    this.subscriptionForm.get("khaliGadiAddPostDays")?.setValue(null);
  }

  setUnlimitedLoad() {
    this.isUnlimitedLoad = true;
    this.subscriptionForm.get("wantLoadContact")?.setValue(-1);
  }

  setCustomLoad() {
    this.isUnlimitedLoad = false;
    this.subscriptionForm.get("wantLoadContact")?.setValue(null);
  }

  onSubmit() {
    if (this.subscriptionForm.valid) {
      // this.spinner.show();

      const payload = this.subscriptionForm.value;
      console.log("payload", payload);
      if (this.subscriptionData && this.subscriptionData._id) {
        console.log("Id", this.subscriptionData._id);
        // 👉 EDIT mode
        this.subscriptionListService
          .updateSubscriptionPlan(this.subscriptionData._id, payload)
          .subscribe({
            next: (res: any) => {
              this.spinner.hide();
              this.toastr.success(res.message || "Plan updated successfully");
              this.save.emit(payload.planType); // notify parent to refresh list
              this.close();
            },
            error: (err) => {
              this.spinner.hide();
              this.toastr.error(err.message || "Update failed");
            },
          });
      } else {
        // 👉 ADD mode
        this.subscriptionListService.addSubscriptionPlan(payload).subscribe({
          next: (res: any) => {
            this.spinner.hide();
            this.toastr.success(res.message || "Plan added successfully");
            this.save.emit(res); // notify parent to refresh list
            this.close();
          },
          error: (err) => {
            this.spinner.hide();
            this.toastr.error(err.message || "Add failed");
          },
        });
      }
    } else {
      this.subscriptionForm.markAllAsTouched(); // show validation errors
    }
  }

  close() {
    this.closeModal.emit();
    this.subscriptionForm.reset();
  }
}
